<script setup lang="ts">
defineProps({
	type: {
		type: String,
		default: "text"
	},
	placeholder: {
		type: String,
		default: "Placeholder"
	},
	iconName: {
		type: String,
		default: ""
	},
	modelValue: {
		type: String,
		default: ""
	}
});
const emit = defineEmits(["update:modelValue", "focus", "enter"]);

const id = useId();
const isFocused = ref(false);

const onFocus = (value: boolean) => {
	isFocused.value = value;
	if (value) {
		emit("focus", value);
	}
};
const onEnter = (event: any) => {
	event.target.blur();
	emit("enter", event.target.value);
};
</script>

<template>
	<div
		class="flex border border-[#E4E4E4] h-[50px] rounded-xs hover:border-green duration-100"
		:class="isFocused && '!border-green'"
	>
		<label
			v-if="iconName"
			class="flex justify-center items-center px-3 cursor-pointer"
			:for="id"
		>
			<AppButtonIcon
				class="text-black"
				:name="iconName"
				tag="div"
			/>
		</label>
		<input
			:id="id"
			class="w-full h-[50px] bg-transparent text-sm placeholder:text-green-dark focus-visible:outline-none"
			:class="iconName ? 'py-2 pr-4' : 'py-4 px-4'"
			:placeholder="placeholder"
			:type="type"
			:value="modelValue"
			@keydown.enter="onEnter"
			@focusin="onFocus(true)"
			@focusout="onFocus(false)"
			@input="$emit('update:modelValue', ($event.target as any).value)"
		/>
	</div>
</template>
